import { Flex, FlexProps } from '@chakra-ui/react';
import { ReactElement } from 'react';

import Button from '../../../../../../../components/ui/buttons/Button';

type OfferModalActionsProps = FlexProps & {
  onCancel: () => void;
  onPrimary: () => void;
  primaryLabel: string;
  isPending: boolean;
  isPrimaryDisabled?: boolean;
  primaryIcon?: ReactElement;
};

const OfferModalActions = ({
  onCancel,
  onPrimary,
  primaryLabel,
  isPending,
  isPrimaryDisabled = false,
  primaryIcon,
  ...flexProps
}: OfferModalActionsProps) => (
  <Flex gap="10px" {...flexProps}>
    <Button
      flex="1"
      variant="outline"
      onClick={onCancel}
      isDisabled={isPending}
      borderRadius="full"
      fontWeight="600"
      fontSize="13px"
    >
      Cancel
    </Button>
    <Button
      flex="1"
      onClick={onPrimary}
      isDisabled={isPrimaryDisabled || isPending}
      isLoading={isPending}
      leftIcon={primaryIcon}
      bg="leaseEndYellow"
      color="leaseEndBlue"
      borderRadius="full"
      fontWeight="800"
      fontSize="13px"
      _hover={{ bg: 'yellowLight' }}
    >
      {primaryLabel}
    </Button>
  </Flex>
);

export default OfferModalActions;
